import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from '@emailjs/browser';

const FormContactFr = () => {
     
    const [name, setName] = useState('');
    const [city, setCity] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [commentOn, setCommentOn] = useState('- Choisir -');
    const [commentDetails, setCommentDetails] = useState('');
    const [messageSent, setMessageSent] = useState();
    const [messageError, setMessageError] = useState();
    const [captchaValue, setCaptchaValue] = useState(null);
    const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    
    const renderTextField = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_text'>
                    <input name={inputData.name} 
                        id={inputData.id} 
                        type={inputData.type} 
                        value={ value } 
                        className='medium' 
                        aria-invalid="false" 
                        aria-required={inputData.ariaRequired} 
                        aria-describedby={inputData.description}
                        onChange={(e) => onChange(e.target.value)}>
                    </input>
                    {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
                </div>
            </>
        );
    }

    const renderTextArea = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_textarea'>
                <textarea name={inputData.name} 
                    id={inputData.id} 
                    className='textarea medium' 
                    value={value} 
                    aria-invalid="false" rows='10' cols='50'
                    aria-describedby={inputData.description}
                    onChange={(e) => onChange(e.target.value)}/>
                {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
            </div>
            </>
        );
    }


    const renderPhoneField = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_email'>
                <input 
                name={inputData.name} 
                id={inputData.id} 
                type={inputData.type} 
                value={value} 
                className='medium' 
                aria-required="true" aria-invalid="false"
                aria-describedby={inputData.description}
                onChange={(e) => onChange(e.target.value)}>
                </input>
                {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
            </div>
            </>
        );
    }

    const renderEmailField = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_email'>
                <input 
                name={inputData.name} 
                id={inputData.id} 
                type='email' 
                value={value} 
                className='medium' 
                aria-required="true" aria-invalid="false" aria-describedby="field_description_email"
                onChange={(e) => onChange(e.target.value)}>
                </input>
            </div>
            <div className={`sp_field_description ${isEmail(value) ? "" : "invalid"}`} id="field_description_email">{!isEmail(value) ? inputData.description : "Merci"}</div>
            </>
        );
    }

    
    const renderDropdown = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_select'>
                    <select 
                        name={inputData.name} 
                        id={inputData.id} 
                        className='medium field_select' 
                        aria-required="true" 
                        aria-invalid="false"
                        value={ value }
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {inputData.option.map(({value, label}, i) => <option key={`${inputData.name}-${i}`} value={value}>{label}</option>)}
                    </select>
                </div>
            </>
        )
    }

    const renderName = () => {
        const inputData = {
            name: 'name',
            id: 'nom',
            label: 'Nom',
            type: 'text',
            value: '',
            required: true,
            ariaRequired: 'true',
            description: 'field_description_name',
            message: 'Votre nom est obligatoire.'
        }
        return renderTextField(inputData, name, setName);
    }

    const renderCity = () => {
        const inputData = {
            name: 'city',
            id: 'location',
            label: 'Ville',
            type: 'text',
            value: '',
            required: true,
            ariaRequired: 'true',
            description: 'field_description_city',
            message: 'Votre emplacement est obligatoire.'
        }
        return renderTextField(inputData, city, setCity);
    }

    const renderEmailDetails = () =>{
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            label: 'Adresse courriel',
            type: 'email',
            required: true,
            description: 'Veuillez fournir votre adresse électronique',
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress);
    }

    const renderPhoneDetails = () =>{
        const inputData = {
            name: 'phone',
            id: 'phoneNumber',
            label: 'Téléphone',
            type: 'tel',
            required: false,
            description: 'field_description_phone',
            message: 'Votre numéro de téléphone est facultatif.'
        }
        return renderPhoneField(inputData, phone, setPhone);
    }
    
    const renderCommentChoices = () => {
        const inputData = {
            name: 'commentChoice',
            id: 'commentChoice',
            label: 'Sélectionner',
            option: [
                {label: '- Choisir -', value: 'Choisir'},
                {label: 'Général', value: 'Général'},
                {label: 'Site web', value: 'Site web'},
                {label: 'Vidéos archivées', value: 'Vidéos archivées'},
                {label: 'Émissions de CPAC', value: 'Émissions de CPAC'},
                {label: 'Carrières', value: 'Carrières'},
                {label: 'CPAC dans votre région', value: 'CPAC dans votre région'},
                {label: 'Commander une vidéo', value: 'Commander une vidéo'},
                {label: 'Médias sociales', value: 'Médias sociales'},
            ],
            required: true,
        };

        return renderDropdown(inputData, commentOn, setCommentOn);
    }

    const renderComments = () => {
        const inputData = {
            name: 'comments',
            id: 'comments',
            label: 'Commentaires',
            description: 'field_description_comments',
            message: 'Veuillez nous faire part de vos commentaires ou de vos questions.',
            required: true,
        }
        return renderTextArea(inputData, commentDetails, setCommentDetails);
    }

    const captchaRef = useRef(null);
    
    const onReCaptchaChange = (value) => {
        setCaptchaValue(value);
    }

    const buttonDisabled = (captchaValue) => {
        return (
            !captchaValue ? "disabled" : ""
        )
    }

    const handleSubmit = (e) => {
    e.preventDefault();
    

    captchaRef.current.reset();

    const templateParams = {
        senderLanguage: "Français",
        senderName: name, 
        senderCity: city, 
        senderEmail: emailAddress ? emailAddress : "webform@cpac.ca", 
        senderPhone: phone, 
        senderTopic: commentOn, 
        senderComments: commentDetails
    };
    emailjs.send('outlook_service', 'contact_form_template', templateParams, process.env.REACT_APP_EMAILJS_KEY)
        .then(function() {
            setMessageSent(true);
            e.target.reset(); // reset the form
        }, function(error) {
            setMessageError(true);
    });

    
    }

    return (
        <>
        {
            messageSent ? <h2 className='form_wrapper message_success'>Nous vous remercions de votre commentaire.</h2> : messageError ? <h2 className='form_wrapper message_fail'>Désolé, il y a eu un problème avec votre envoi. Prière de réessayer plus tard.</h2> : 
            <div id="form_wrapper" className="form_wrapper" itemScope itemType="https://schema.org/ContactPage">
                <form onSubmit={(e) => handleSubmit(e)} itemScope itemType="https://schema.org/WebPageElement">
                    <div className="form_body" itemProp='mainEntityOfPage'>
                        { renderName() }
                        { renderCity() }
                        { renderEmailDetails() }
                        { renderPhoneDetails() }
                        { renderCommentChoices() }
                        { renderComments() }
                    </div>
                    <ReCAPTCHA sitekey={captchaKey} ref={captchaRef} onChange={onReCaptchaChange} hl="fr" />
                    <div className='form_footer left_label'>
                        <button type="submit" name='submit' value='soumettre' className="btn--primary" disabled={buttonDisabled(captchaValue)}>Soumettre</button>
                    </div>
                </form>
            </div>
        }
        </>
    )
}


export default FormContactFr;